import { TFaqCategoryEntry } from './types';

export const FAQ_TRANSLATION_PREFIX =
  'chatPage.servicesSection.exemplaryQuestions.';

export enum EFaqsCategoryIcons {
  BUZZWORDS = 'megaphone',
  KNOWLEDGE_QUESTIONS = 'book',
  PERFORM = 'stats',
}

// INFO: Single source of truth for FAQ category definitions.
export const FAQ_CATEGORY_CONFIG: Record<EFaqsCategoryIcons, TFaqCategoryEntry> = {
  [EFaqsCategoryIcons.PERFORM]: {
    phraseSegment: 'performService',
    tooltipText: 'chatPage.chatInput.tooltip.stats',
  },
  [EFaqsCategoryIcons.KNOWLEDGE_QUESTIONS]: {
    phraseSegment: 'manTraining',
    tooltipText: 'chatPage.chatInput.tooltip.book',
  },
  [EFaqsCategoryIcons.BUZZWORDS]: {
    phraseSegment: 'buzzword',
    tooltipText: 'chatPage.chatInput.tooltip.buzzwords',
  },
};